import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";

import PlushieUpgradeRelation from "./plushie-upgrade-relation.model";

export default class PlushieUpgradeRelationRepository extends BasicRepository<PlushieUpgradeRelation> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<PlushieUpgradeRelation>,
    responseParser: ApiCollectionResponseParserService<PlushieUpgradeRelation>
  ) {
    super("plushie_upgrade_relations", api, objectBuilder, responseParser);
  }

  public async getByPlushieId(
    plushieId: string,
    isDisablePagination = false
  ): Promise<PlushieUpgradeRelation[]> {
    const collection = await this.fetchList(
      { plushie: plushieId },
      1,
      isDisablePagination ? BasicRepository.MAX_ITEMS_PER_PAGE : undefined
    );

    return collection.getItems();
  }

  public async getByPlushieIds(
    plushieIds: string[],
    isDisablePagination = false
  ): Promise<PlushieUpgradeRelation[]> {
    const collection = await this.fetchList(
      { plushie: plushieIds },
      1,
      isDisablePagination ? BasicRepository.MAX_ITEMS_PER_PAGE : undefined
    );

    return collection.getItems();
  }

  protected prepareData(
    item: PlushieUpgradeRelation
  ): Record<string, string | number> {
    const data: Record<string, string> = {
      id: item.id,
      plushie: item.plushie,
      upgrade: item.upgrade,
    };

    return data;
  }
}
